import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export type Lang = 'es' | 'en';

type TranslationMap = Record<string, unknown>;

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private readonly http = inject(HttpClient);
  private readonly translations = signal<TranslationMap>({});
  readonly lang = signal<Lang>('es');

  async load(lang: Lang = 'es'): Promise<void> {
    const data = await firstValueFrom(
      this.http.get<TranslationMap>(`/i18n/${lang}.json`),
    );
    this.translations.set(data);
    this.lang.set(lang);
  }

  t(key: string): string {
    const parts = key.split('.');
    let node: unknown = this.translations();
    for (const part of parts) {
      if (typeof node !== 'object' || node === null) return key;
      node = (node as TranslationMap)[part];
    }
    return typeof node === 'string' ? node : key;
  }
}
